import React from "react";
import AxisNumberInput from "../ui/AxisNumberInput";
import FieldLabel from "../ui/FieldLabel";
import InfoTooltip from "../ui/InfoTooltip";

const AXIS_LABELS = ["X", "Y", "Z"];
const AXIS_KEYS = ["x", "y", "z"];

function JointAxisEditor({
  axis,
  disabled,
  editingInputs,
  infoText,
  label,
  onAxisChange,
  onAxisSelect,
  setEditingInputs,
  validationMessage,
  isAlignedToAxis,
}) {
  return (
    <div>
      <FieldLabel className="block mb-2">{label}</FieldLabel>
      <div className="flex items-center gap-2">
        {AXIS_LABELS.map((axisLabel, idx) => (
          <button
            key={axisLabel}
            onClick={() => onAxisSelect(idx)}
            className={`px-3 py-1 text-xs rounded border ${
              isAlignedToAxis(axis, idx)
                ? "border-green-600 bg-green-900/20 text-green-300"
                : "border-gray-700 hover:border-gray-600"
            }`}
            type="button"
            disabled={disabled}
          >
            {axisLabel}
          </button>
        ))}
      </div>
      <div className="mt-2">
        <FieldLabel className="inline-flex items-center gap-1.5 mb-1">
          Custom Axis
          <InfoTooltip text={infoText} widthClass="w-64" />
        </FieldLabel>
        <div className="grid grid-cols-3 gap-2">
          {AXIS_KEYS.map((key, idx) => {
            const inputKey = `axis-${idx}`;
            const isEditing = editingInputs[inputKey];
            const baseValue = Number(axis?.[idx] ?? 0);
            const displayValue = isEditing !== undefined ? editingInputs[inputKey] : baseValue;
            return (
              <div key={key} className="space-y-1">
                <AxisNumberInput
                  axis={key}
                  labelClassName="text-xs panel-text-helper uppercase w-3 text-center"
                  value={displayValue}
                  dragValue={baseValue}
                  onDragValueChange={(nextValue) => onAxisChange(idx, nextValue)}
                  onChange={(e) => {
                    const val = e.target.value;
                    setEditingInputs((prev) => ({ ...prev, [inputKey]: val }));
                    onAxisChange(idx, val);
                  }}
                  onFocus={(e) => {
                    setEditingInputs((prev) => ({ ...prev, [inputKey]: e.target.value }));
                  }}
                  onBlur={(e) => {
                    const numVal = parseFloat(e.target.value) || 0;
                    onAxisChange(idx, numVal);
                    setEditingInputs((prev) => {
                      const next = { ...prev };
                      delete next[inputKey];
                      return next;
                    });
                  }}
                  inputClassName="w-full bg-gray-800 border border-gray-600 rounded px-2 py-1 text-gray-100 text-sm"
                  inputProps={{ step: "0.01", disabled }}
                />
              </div>
            );
          })}
        </div>
        {validationMessage ? (
          <p className="mt-1 text-xs text-amber-300">{validationMessage}</p>
        ) : null}
      </div>
    </div>
  );
}

export default React.memo(JointAxisEditor);
